import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { currentVisit, tecnicos, error } from '../store/state';
import { ensureVisitLoaded, reasignarVisita } from '../store/actions/visit.actions';
import { esDiaPermitido, MENSAJE_DIA_NO_PERMITIDO } from '../utils/businessDays';
import { Shell } from '../layout/Shell';

interface Props {
  id: string;
}

export function ReasignarView({ id }: Props) {
  useEffect(() => {
    ensureVisitLoaded(id);
  }, [id]);

  const v = currentVisit.value;
  if (!v) return <Shell tab="agenda">{null}</Shell>;

  const localValue = v.fechaProgramada
    ? new Date(new Date(v.fechaProgramada).getTime() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16)
    : '';

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const fechaElegida = fd.get('fechaProgramada')
      ? new Date(String(fd.get('fechaProgramada')))
      : null;
    if (fechaElegida && v.tipo !== 'emergencia' && !esDiaPermitido(fechaElegida)) {
      error.value = MENSAJE_DIA_NO_PERMITIDO;
      return;
    }
    const fecha = fechaElegida ? fechaElegida.toISOString() : null;
    try {
      await reasignarVisita(v.id, (fd.get('tecnicoId') as string) || null, fecha, String(fd.get('motivo')));
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="agenda">
      <h2>Reasignar</h2>
      <div class="card">
        <strong>{v.client?.nombre}</strong>
      </div>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Técnico</label>
        <select name="tecnicoId">
          <option value="">Sin asignar (pool)</option>
          {tecnicos.value.map((t) => (
            <option key={t.id} value={t.id} selected={t.id === v.tecnicoId}>
              {t.nombre}
              {t.disponible ? '' : ' (no disponible)'}
            </option>
          ))}
        </select>
        <label>Nueva fecha</label>
        <input name="fechaProgramada" type="datetime-local" defaultValue={localValue} />
        {v.tipo !== 'emergencia' && (
          <p class="muted" style={{ margin: '2px 0 0', fontSize: 12 }}>
            Las visitas programadas solo se pueden agendar martes, jueves o viernes.
          </p>
        )}
        <label>Motivo</label>
        <textarea name="motivo" />
        <button class="primary" type="submit">
          Confirmar
        </button>
        <button class="secondary" type="button" onClick={() => route(`/visitas/${v.id}`)}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
